/* eslint-disable*/
import axios from 'axios'

require("dotenv").config();
const API_URL = process.env.APIURL
const VueVueStoreService = {
    async get(url, store) {
        console.log('store',store)
        console.log('url',url)
        var request= {
            headers:this.getHeaders(),
            method: "GET",
            url : API_URL+ url,
        }
        const resp = await store.dispatch("back/EXECUTE",request)
        return resp;
    }, 
    
    async postFile(url, data, store, config = {}) {
      const token = localStorage.getItem("accessToken")
      return await axios.post(`${process.env.APIURL}${url}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: config.onUploadProgress, 
        ...config,
      })
    },
    
    async getFile(url, store) {
        var request= {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem("accessToken")}`,
            },
            responseType: 'blob',
            method: "GET",
            url : API_URL+ url,
        }
        const resp = await store.dispatch("back/DOWNLOAD",request)
        return resp;
    }, 
    async delete(url,store){
        var request = {
            headers:this.getHeaders(),
            method: "DELETE",
            url : API_URL+ url,
        }
        const resp = await store.dispatch("back/EXECUTE",request)
        return resp;
    }, 
    async deleteWithData(url,data,store){
        var request = {
            headers:this.getHeaders(),
            method: "DELETE",
            url : API_URL+ url,
            data: data
        }
        const resp = await store.dispatch("back/EXECUTE",request)
        return resp;
    }, 
    async post(url,data,store){
        var request = {
            headers:this.getHeaders(),
            method: "POST",
            url : API_URL+ url,
            data:data
        }
        const resp = await store.dispatch("back/EXECUTE",request)
        return resp;
    }, 
    async put(url,data,store){
        var request = {
            headers:this.getHeaders(),
            method: "PUT",
            url : API_URL+ url,
            data:data
        }
        const resp = await store.dispatch("back/EXECUTE",request)
        return resp;
    },
    async patch(url,data,store){
        var request = {
            headers:this.getHeaders(),
            method: "PATCH",
            url : API_URL+ url,
            data:data
        }
        const resp = await store.dispatch("back/EXECUTE",request)
        return resp;
    }, 
    getHeaders(){
        return  {
            'Authorization': `Bearer ${localStorage.getItem("accessToken")}`
        }
    },
}
export default VueVueStoreService;